"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

const AUTH_ERROR_MESSAGES = [
  "Session expired",
  "Not authenticated",
  "invalid token",
];

function isAuthError(error: unknown): boolean {
  if (error instanceof Error) {
    return AUTH_ERROR_MESSAGES.some((msg) =>
      error.message.toLowerCase().includes(msg.toLowerCase()),
    );
  }
  return false;
}

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            retry: (failureCount, error) => {
              // Don't retry on auth errors
              if (isAuthError(error)) {
                return false;
              }
              return failureCount < 1;
            },
          },
          mutations: {
            retry: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
